import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';
import type { TrackPagesOnOrderNewCardsModal } from '@/features/orderNewCards/types';

export const RFID_FLOW_NAME = 'rfid_card_order';

const debugConfig = createDebugConfig();

// Entry points tracking
export const trackOrderEntryPoint = (source: TrackPagesOnOrderNewCardsModal) => {
    trackCustomEvent(
        'rfid_order_start',
        {
            trigger: 'click',
            flow_name: RFID_FLOW_NAME,
            element_state: 'order_button',
            element_name: source,
        },
        debugConfig
    );
};

// Step tracking
export const trackOrderStep = (
    stepName: string,
    action: 'view' | 'complete' | 'back',
    source: TrackPagesOnOrderNewCardsModal
) => {
    trackCustomEvent(
        'rfid_order_step',
        {
            trigger: action === 'view' ? 'visibility' : 'click',
            flow_name: RFID_FLOW_NAME,
            element_name: source,
            element_state: stepName,
        },
        debugConfig
    );
};

// Order completion tracking
export const trackOrderComplete = (source: TrackPagesOnOrderNewCardsModal, hasCustomization: boolean) => {
    trackCustomEvent(
        'rfid_order_complete',
        {
            trigger: 'click',
            flow_name: RFID_FLOW_NAME,
            element_name: source,
            element_state: hasCustomization ? 'order_with_cards_customization' : 'order_without_cards_customization',
        },
        debugConfig
    );
};

// Order error tracking
export const trackOrderError = (errorType: string) => {
    trackCustomEvent(
        'rfid_order_error',
        {
            trigger: 'system',
            flow_name: RFID_FLOW_NAME,
            element_state: errorType,
        },
        debugConfig
    );
};

// Abandonment tracking
export const trackOrderAbandon = (stepName: string, source: TrackPagesOnOrderNewCardsModal) => {
    trackCustomEvent(
        'rfid_order_abandon',
        {
            trigger: 'click',
            flow_name: RFID_FLOW_NAME,
            element_name: source,
            element_state: stepName,
        },
        debugConfig
    );
};
